import { render, staticRenderFns } from "./DiscountManage.vue?vue&type=template&id=26397e0a&"
import script from "./DiscountManage.vue?vue&type=script&lang=js&"
export * from "./DiscountManage.vue?vue&type=script&lang=js&"
import style0 from "./DiscountManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports